export const oimStatusConfig = {
    type: 'oim',
    mainId: 'il_ocean_import_id',
    hblId: 'il_ocean_import_hbl_id',
    cntrId: 'il_ocean_import_cntr_id',
    listHeight: '58%',
    inputHeight: '42%',
    statusData: 'oimStatusUpdateForm',
    hblShipmentList: 'oimHblUpdateForm',
    cntrShipmentList: 'oimContainerUpdateForm',
    aliasShipmentList: 'oimContainerAliasUpdateForm',
    reducerActions: ['setOimStatusUpdate', 'addOimStatus', 'deleteOimStatus'],
};
export const oexStatusConfig = {
    type: 'oex',
    mainId: 'il_ocean_export_id',
    hblId: 'il_ocean_export_hbl_id',
    cntrId: 'il_ocean_export_cntr_id',
    listHeight: '45%',
    inputHeight: '55%',
    statusData: 'oexStatusUpdateForm',
    hblShipmentList: 'oexHblUpdateForm',
    cntrShipmentList: 'oexContainerUpdateForm',
    aliasShipmentList: 'oexContainerAliasUpdateForm',
    reducerActions: ['setOexStatusUpdate', 'addOexStatus', 'deleteOexStatus'],
};
export const aimStatusConfig = {
    type: 'aim',
    mainId: 'il_air_import_id',
    hblId: 'il_air_import_hbl_id',
    cntrId: 'il_air_import_cntr_id',
    listHeight: '58%',
    inputHeight: '42%',
    statusData: 'aimStatusUpdateForm',
    hblShipmentList: 'aimHblUpdateForm',
    cntrShipmentList: 'aimContainerUpdateForm',
    aliasShipmentList: 'aimContainerAliasUpdateForm',
    reducerActions: ['setAimStatusUpdate', 'addAimStatus', 'deleteAimStatus'],
};
export const aexStatusConfig = {
    type: 'aex',
    mainId: 'il_air_export_id',
    hblId: 'il_air_export_hbl_id',
    cntrId: 'il_air_export_cntr_id',
    listHeight: '45%',
    inputHeight: '55%',
    statusData: 'aexStatusUpdateForm',
    hblShipmentList: 'aexHblUpdateForm',
    cntrShipmentList: 'aexContainerUpdateForm',
    aliasShipmentList: 'aexContainerAliasUpdateForm',
    reducerActions: ['setAexStatusUpdate', 'addAexStatus', 'deleteAexStatus'],
};
export const truckingStatusConfig = {
    type: 'trucking',
    mainId: 'id',
    hblId: 'il_ftl_ltl_id',
    cntrId: 'il_ftl_ltl_id',
    listHeight: '45%',
    inputHeight: '55%',
    statusData: 'truckingStatusUpdateForm',
    hblShipmentList: 'truckingHblUpdateForm',
    cntrShipmentList: 'truckingContainerUpdateForm',
    aliasShipmentList: 'truckingContainerAliasUpdateForm',
    reducerActions: ['setTruckingStatusUpdate', 'addTruckingStatus', 'deleteTruckingStatus'],
};
